 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		4: 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		4: 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "" + ({"0":"44d7561441af2cb78c7444c9dd115d1124704146","1":"c8f7fe3b0e41be846d5687592cf2018ff6e22687","2":"styles","3":"514f06fae3189f13773df5aa1412153fdef6444f","5":"40f86a5f","7":"component---cache-caches-gatsby-plugin-offline-app-shell-js","8":"component---src-pages-404-js","9":"component---src-pages-brand-guidelines-visual-identity-colour-mdx","10":"component---src-pages-brand-guidelines-visual-identity-logo-mdx","11":"component---src-pages-brand-guidelines-visual-identity-mdx","12":"component---src-pages-index-mdx","13":"component---src-pages-overview-benefits-mdx","14":"component---src-pages-overview-license-mdx","15":"component---src-pages-overview-purpose-mdx","16":"component---src-pages-product-components-mdx","17":"component---src-pages-product-design-tokens-mdx","18":"component---src-pages-product-elements-mdx","19":"component---src-pages-product-mdx","22":"polyfills-core-js","23":"polyfills-css-shim","24":"polyfills-dom"}[chunkId]||chunkId) + "-" + {"0":"16a0f9839eb922c62ceb","1":"1ea9f01114a427f6f744","2":"2d82ac8e3afc0c213061","3":"8ecec1eb299fd94a33e5","5":"beadaffaafc0e9c6e4e1","7":"c9875e2473a7c518755f","8":"22b4b6057ae109023d8d","9":"26bf39937806e8d5d7e2","10":"f80306f04f7134cd2bec","11":"eb0dacbf9119206f79dc","12":"2164a23162734efb6e33","13":"0799f08fdabc3050b34c","14":"94af2069a21c368c9f76","15":"3b66246092f608de9630","16":"3be71743d257416e858b","17":"1d351d54bdb1be63118e","18":"856490529db5140d08dd","19":"f689b19b69bac33b3ffd","22":"7929580b38ff491b6e60","23":"e609e42f99147fa531dc","24":"1174a6041ab5fbc05d26","25":"48a6aa1cc15f44629d94","26":"cf6a3d22ba50ab855a4b","27":"098522cec6054090e820","28":"9732d54c33d4329a793a","29":"df642e7a46e3e2a38b5b","30":"79ad9751c55f7aa78956","31":"be9d019c5ef8afefe25b","32":"671480075526bfc5fe80","33":"06325e54efe549c6591a","34":"b01310f66938b466bd95","35":"115210f0477846312350","36":"d255f4f9fcab490be3c8","37":"927632172bd030e1ca59","38":"b1a7f44d0299f1c44551","39":"58def92d6482a895ef39","40":"f850835c096b541d4a4a","41":"a5e9ac4c157e1c41c37b","42":"72360f8d3dccea619fa1","43":"8e41d8735bf9855e8cda","44":"22a86000d8a5b50b198e","45":"a08a0b705b4896813e40","46":"5cbf0aa6b0028af93164","47":"2fe6f952fef5e9ac310d","48":"5feb3c4164f7febcc808","49":"16bd78665abdf79b8ef8","50":"087e3b6f56734c467c82","51":"d82105c432ae7d63ede1","52":"0c504391887ff1f39928","53":"9e1821f88d99cb921c74","54":"7f312048246766a7d96a","55":"6ed02966c4941e5a9cb5","56":"f90e75cfee0f983c4fae","57":"56f3fd57fd52165195b4","58":"70caa071940138bfe65d","59":"1cdd28b34c5e747f5039","60":"a00700ca7a2ff34136f4","61":"fee0d3ac556f5b3b1f06","62":"45dbda4d78fff06e0f1a","63":"61a5541effe900fb3a6d","64":"948ed7c6d59e7c187dab","65":"14aa5c3eb9f07cc971ed","66":"f74babff0147f7d7e925","67":"c9e3dff1910ef43edda5","68":"074422e7198dad970cc5","69":"75d4aa3af9d6d5f532ce","70":"a85214528fc18acbaec1","71":"44037c5861a2f8dce916","72":"00271a0d50f2aebb11d8","73":"a491bfc574e703117ef5","74":"625e2aefb606b44335b0","75":"fce60f2c5fec737c8a85","76":"8a1c4aa2d96882db03e7","77":"7de88d5cbef35650c9e5","78":"4d2deecf6bebfb3d5da4","79":"036d90efd31a2111fbab","80":"ca81dae2b994d9e42bb8","81":"4f5687ff21a10112b444","82":"d6446bca19afe06cae35","83":"48f466bb03ccf8ad433e","84":"488c38591414c1da3f6e","85":"b33c70f5b19728030fac","86":"0ed785c6fbc02d2815d8","87":"1320f07aedd45922d21b","88":"a943e078c9ec626112b1","89":"e85365a5d61763e9c83d","90":"ebf737bb2ab20d7aa033","91":"6b91f2b510af8a837235","92":"e9f5836e3cd83cc2b3cf","93":"ab183ae2a5ffac192528","94":"6a4062737695addde392","95":"2122e72b297cc4e20f69","96":"a679e6c12eb16b9a6d69","97":"d6f96ede606c7da6e47a","98":"6dcfb1c45829aa0355e1","99":"54c14e4336ab9c7ccf60","100":"848ec746468e974a3ac6","101":"2195cc765b11a7a29914","102":"2c177c8a273c4e3fce19","103":"92121cc79fd2f4f43535","104":"ad5c507ff86c31f80bf1","105":"18d3fce4626e9849206f","106":"abdad594fa09ab9cea57","107":"ded0ca50615ac531a1b3","108":"206254efbdff899dd77c","109":"69a57342816811cc4af8","110":"1c95bb467a21141c47f7","111":"1bbb2036abaebebb91a0","112":"1b1ed3132328700d7afe","113":"cf0d69aee9fc48edc53a","114":"8e2e57bfd84e62ba46ed","115":"cdc4aa08383339945df5","116":"752d5edd404ef6478d35","117":"9ccdb00982fa4f9be347","118":"c304292bede5e03f335e","119":"eaa61b5aabf8346955e6","120":"882b51c5b57fff80a149","121":"6932c4d39300b639f80e","122":"9f55364ad843ca32d5ed","123":"6f965466c3aee06c19a9","124":"d55f52229c0aa11ded62","125":"5bd508fe8de570fd011d","126":"1aa0f7c456076a276739","127":"777f0c1fe5363f38ea28","128":"02d0ae3651775ffbe41d","129":"0d85bffc73d62e5cf1f2","130":"490634392365f3dfdd81","131":"c48e547b217215f7ad9d","132":"e57270259c7df6d55a8f","133":"da2fd506a40d66b82808","134":"d5e1fea50581f9e677ed","135":"362faf8e9eb078690bed","136":"39cf6ac0f26aa74dedf8","137":"3357263355c0d508a540","138":"ab796aa466cf5d7d6c4a","139":"53d830f3244e9c7f4dc5","140":"3da583145340ff8a26b1","141":"d9991cc2c25c00cd335d","142":"683d7b5d14458a950f93","143":"c045cb5dc820fc9e6f39","144":"ec50114695a75ff85fa0","145":"166fa8c5e1cb68e9e17c","146":"9652722655266122d60d","147":"10b10a9f569705ca14c0","148":"fac528e0fb7c86620156","149":"db600868326058af2601","150":"00468a90c2efe0908503","151":"938502746b480b185b0b","152":"2b466cc7f500a1e865ab","153":"3ccf8e2b1b637a155d54","154":"1eca9bfe1195d345a171","155":"787647066e0bc598ae23","156":"2b2ccefdaa0ca5ad35d4","157":"550b6c052dcf1aaae8ff","158":"50ace7b1785cfbf4ac3a","159":"6fd16f0666b993a286b0","160":"d64da89aea6427ae3958","161":"ef4ed2e679164f2a2cff","162":"4822bc37b338fc9077c1","163":"4c36a47735bff540322a","164":"edeb9883443ae33c2f3d","165":"a3cfd3abb68f106bba66","166":"04a099fe74ead1471381","167":"88f51e4a265dc1f641ca","168":"69f0a2f742149831b03a","169":"3307668df0e27a77d4d7","170":"11a8ffcb1ba9719ac552","171":"efa18585d339735a78c7","172":"90221f193addac873585","173":"13617c7340f9dad78fa9","174":"e4eeb1d3449c818063ec","175":"49a55c629bfca47a63c1","176":"64a8b6bf672c7dc85eed"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"2":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "" + ({"0":"44d7561441af2cb78c7444c9dd115d1124704146","1":"c8f7fe3b0e41be846d5687592cf2018ff6e22687","2":"styles","3":"514f06fae3189f13773df5aa1412153fdef6444f","5":"40f86a5f","7":"component---cache-caches-gatsby-plugin-offline-app-shell-js","8":"component---src-pages-404-js","9":"component---src-pages-brand-guidelines-visual-identity-colour-mdx","10":"component---src-pages-brand-guidelines-visual-identity-logo-mdx","11":"component---src-pages-brand-guidelines-visual-identity-mdx","12":"component---src-pages-index-mdx","13":"component---src-pages-overview-benefits-mdx","14":"component---src-pages-overview-license-mdx","15":"component---src-pages-overview-purpose-mdx","16":"component---src-pages-product-components-mdx","17":"component---src-pages-product-design-tokens-mdx","18":"component---src-pages-product-elements-mdx","19":"component---src-pages-product-mdx","22":"polyfills-core-js","23":"polyfills-css-shim","24":"polyfills-dom"}[chunkId]||chunkId) + "." + {"0":"31d6cfe0d16ae931b73c","1":"31d6cfe0d16ae931b73c","2":"d22fb7b1ec846fa589f1","3":"31d6cfe0d16ae931b73c","5":"31d6cfe0d16ae931b73c","7":"31d6cfe0d16ae931b73c","8":"31d6cfe0d16ae931b73c","9":"31d6cfe0d16ae931b73c","10":"31d6cfe0d16ae931b73c","11":"31d6cfe0d16ae931b73c","12":"31d6cfe0d16ae931b73c","13":"31d6cfe0d16ae931b73c","14":"31d6cfe0d16ae931b73c","15":"31d6cfe0d16ae931b73c","16":"31d6cfe0d16ae931b73c","17":"31d6cfe0d16ae931b73c","18":"31d6cfe0d16ae931b73c","19":"31d6cfe0d16ae931b73c","22":"31d6cfe0d16ae931b73c","23":"31d6cfe0d16ae931b73c","24":"31d6cfe0d16ae931b73c","25":"31d6cfe0d16ae931b73c","26":"31d6cfe0d16ae931b73c","27":"31d6cfe0d16ae931b73c","28":"31d6cfe0d16ae931b73c","29":"31d6cfe0d16ae931b73c","30":"31d6cfe0d16ae931b73c","31":"31d6cfe0d16ae931b73c","32":"31d6cfe0d16ae931b73c","33":"31d6cfe0d16ae931b73c","34":"31d6cfe0d16ae931b73c","35":"31d6cfe0d16ae931b73c","36":"31d6cfe0d16ae931b73c","37":"31d6cfe0d16ae931b73c","38":"31d6cfe0d16ae931b73c","39":"31d6cfe0d16ae931b73c","40":"31d6cfe0d16ae931b73c","41":"31d6cfe0d16ae931b73c","42":"31d6cfe0d16ae931b73c","43":"31d6cfe0d16ae931b73c","44":"31d6cfe0d16ae931b73c","45":"31d6cfe0d16ae931b73c","46":"31d6cfe0d16ae931b73c","47":"31d6cfe0d16ae931b73c","48":"31d6cfe0d16ae931b73c","49":"31d6cfe0d16ae931b73c","50":"31d6cfe0d16ae931b73c","51":"31d6cfe0d16ae931b73c","52":"31d6cfe0d16ae931b73c","53":"31d6cfe0d16ae931b73c","54":"31d6cfe0d16ae931b73c","55":"31d6cfe0d16ae931b73c","56":"31d6cfe0d16ae931b73c","57":"31d6cfe0d16ae931b73c","58":"31d6cfe0d16ae931b73c","59":"31d6cfe0d16ae931b73c","60":"31d6cfe0d16ae931b73c","61":"31d6cfe0d16ae931b73c","62":"31d6cfe0d16ae931b73c","63":"31d6cfe0d16ae931b73c","64":"31d6cfe0d16ae931b73c","65":"31d6cfe0d16ae931b73c","66":"31d6cfe0d16ae931b73c","67":"31d6cfe0d16ae931b73c","68":"31d6cfe0d16ae931b73c","69":"31d6cfe0d16ae931b73c","70":"31d6cfe0d16ae931b73c","71":"31d6cfe0d16ae931b73c","72":"31d6cfe0d16ae931b73c","73":"31d6cfe0d16ae931b73c","74":"31d6cfe0d16ae931b73c","75":"31d6cfe0d16ae931b73c","76":"31d6cfe0d16ae931b73c","77":"31d6cfe0d16ae931b73c","78":"31d6cfe0d16ae931b73c","79":"31d6cfe0d16ae931b73c","80":"31d6cfe0d16ae931b73c","81":"31d6cfe0d16ae931b73c","82":"31d6cfe0d16ae931b73c","83":"31d6cfe0d16ae931b73c","84":"31d6cfe0d16ae931b73c","85":"31d6cfe0d16ae931b73c","86":"31d6cfe0d16ae931b73c","87":"31d6cfe0d16ae931b73c","88":"31d6cfe0d16ae931b73c","89":"31d6cfe0d16ae931b73c","90":"31d6cfe0d16ae931b73c","91":"31d6cfe0d16ae931b73c","92":"31d6cfe0d16ae931b73c","93":"31d6cfe0d16ae931b73c","94":"31d6cfe0d16ae931b73c","95":"31d6cfe0d16ae931b73c","96":"31d6cfe0d16ae931b73c","97":"31d6cfe0d16ae931b73c","98":"31d6cfe0d16ae931b73c","99":"31d6cfe0d16ae931b73c","100":"31d6cfe0d16ae931b73c","101":"31d6cfe0d16ae931b73c","102":"31d6cfe0d16ae931b73c","103":"31d6cfe0d16ae931b73c","104":"31d6cfe0d16ae931b73c","105":"31d6cfe0d16ae931b73c","106":"31d6cfe0d16ae931b73c","107":"31d6cfe0d16ae931b73c","108":"31d6cfe0d16ae931b73c","109":"31d6cfe0d16ae931b73c","110":"31d6cfe0d16ae931b73c","111":"31d6cfe0d16ae931b73c","112":"31d6cfe0d16ae931b73c","113":"31d6cfe0d16ae931b73c","114":"31d6cfe0d16ae931b73c","115":"31d6cfe0d16ae931b73c","116":"31d6cfe0d16ae931b73c","117":"31d6cfe0d16ae931b73c","118":"31d6cfe0d16ae931b73c","119":"31d6cfe0d16ae931b73c","120":"31d6cfe0d16ae931b73c","121":"31d6cfe0d16ae931b73c","122":"31d6cfe0d16ae931b73c","123":"31d6cfe0d16ae931b73c","124":"31d6cfe0d16ae931b73c","125":"31d6cfe0d16ae931b73c","126":"31d6cfe0d16ae931b73c","127":"31d6cfe0d16ae931b73c","128":"31d6cfe0d16ae931b73c","129":"31d6cfe0d16ae931b73c","130":"31d6cfe0d16ae931b73c","131":"31d6cfe0d16ae931b73c","132":"31d6cfe0d16ae931b73c","133":"31d6cfe0d16ae931b73c","134":"31d6cfe0d16ae931b73c","135":"31d6cfe0d16ae931b73c","136":"31d6cfe0d16ae931b73c","137":"31d6cfe0d16ae931b73c","138":"31d6cfe0d16ae931b73c","139":"31d6cfe0d16ae931b73c","140":"31d6cfe0d16ae931b73c","141":"31d6cfe0d16ae931b73c","142":"31d6cfe0d16ae931b73c","143":"31d6cfe0d16ae931b73c","144":"31d6cfe0d16ae931b73c","145":"31d6cfe0d16ae931b73c","146":"31d6cfe0d16ae931b73c","147":"31d6cfe0d16ae931b73c","148":"31d6cfe0d16ae931b73c","149":"31d6cfe0d16ae931b73c","150":"31d6cfe0d16ae931b73c","151":"31d6cfe0d16ae931b73c","152":"31d6cfe0d16ae931b73c","153":"31d6cfe0d16ae931b73c","154":"31d6cfe0d16ae931b73c","155":"31d6cfe0d16ae931b73c","156":"31d6cfe0d16ae931b73c","157":"31d6cfe0d16ae931b73c","158":"31d6cfe0d16ae931b73c","159":"31d6cfe0d16ae931b73c","160":"31d6cfe0d16ae931b73c","161":"31d6cfe0d16ae931b73c","162":"31d6cfe0d16ae931b73c","163":"31d6cfe0d16ae931b73c","164":"31d6cfe0d16ae931b73c","165":"31d6cfe0d16ae931b73c","166":"31d6cfe0d16ae931b73c","167":"31d6cfe0d16ae931b73c","168":"31d6cfe0d16ae931b73c","169":"31d6cfe0d16ae931b73c","170":"31d6cfe0d16ae931b73c","171":"31d6cfe0d16ae931b73c","172":"31d6cfe0d16ae931b73c","173":"31d6cfe0d16ae931b73c","174":"31d6cfe0d16ae931b73c","175":"31d6cfe0d16ae931b73c","176":"31d6cfe0d16ae931b73c"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// run deferred modules from other chunks
 	checkDeferredModules();
